import { CardComponentProps } from "@~/types/types";
import {
  transformVariantPrice,
  isPriceAtLeastMinimumThreshold,
  getCreditMessage,
} from "./utils";
import {
  transformPricePerUnit,
  allVariantsHaveSamePrice,
} from "../__shared__/PriceUtils/priceUtils";
import { PricePresentation } from "../__shared__/PriceUtils/PricePresentation";
import { useVariant } from "@~/contexts/VariantContext/VariantContext.tsx";
import { useFeatureFlags } from "@~/flags/flags";

export function VariantPrice({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { newCreditTextEnabled } = useFeatureFlags();
  const { variants = [] } = product;
  const variantsHaveSamePrice = allVariantsHaveSamePrice(variants);

  const { variant } = useVariant();
  const pricePerUnit =
    variant && "pricePerUnit" in variant
      ? (variant.pricePerUnit ?? undefined)
      : undefined;

  if (!variant?.price) return null;
  const { price } = variant;

  const transformedVariantPrice = transformVariantPrice(price);

  if (!isPriceAtLeastMinimumThreshold(transformedVariantPrice)) return null;

  const unitPriceInfo =
    pricePerUnit && variantsHaveSamePrice
      ? transformPricePerUnit(pricePerUnit)
      : undefined;

  const creditMessage = getCreditMessage(
    transformedVariantPrice,
    product,
    Boolean(newCreditTextEnabled?.value),
  );

  return (
    <PricePresentation
      transformedVariantPrice={transformedVariantPrice}
      creditMessage={creditMessage}
      product={product}
      configProps={configProps}
      unitPriceInfo={unitPriceInfo}
    />
  );
}
